/* Justyol Flash Drop — reusable landing behaviour.
   State (teaser / live / out) is derived from the real drop date + real stock;
   no fabricated stock-decay or entrant inflation. The entrant count is the real
   number returned by the backend (falls back to the seeded value offline). */
(function () {
  var root = document.querySelector('[data-jy-drop]');
  if (!root) return;

  var band = root.querySelector('[data-jy-band]');
  var lang = root.getAttribute('data-lang') || 'fr';
  var isAr = lang.indexOf('ar') === 0;
  /* drop datetime — bare local strings are Morocco wall-clock → pin to +01:00 */
  var dropRaw = (root.getAttribute('data-drop-date') || '').trim();
  var dropDate = 0; // ms epoch, 0 = live now
  if (dropRaw) {
    if (!/[zZ]|[+-]\d\d:?\d\d$/.test(dropRaw)) dropRaw = dropRaw.replace(' ', 'T') + '+01:00';
    var parsed = Date.parse(dropRaw);
    if (!isNaN(parsed)) dropDate = parsed;
  }
  var stock = parseInt(root.getAttribute('data-stock'), 10);
  var total = parseInt(root.getAttribute('data-total'), 10) || stock || 0;
  if (isNaN(stock)) stock = total;
  var endpoint = root.getAttribute('data-endpoint') || '';
  var copiedTxt = root.getAttribute('data-copied') || (isAr ? 'تنسخ ✓' : 'Copié ✓');
  var homeUrl = root.getAttribute('data-home') || '/';
  var unlockRedirect = root.getAttribute('data-unlock-redirect') !== 'false';
  var product = root.getAttribute('data-product') || '';

  var cards = {
    teaser: root.querySelector('[data-card="teaser"]'),
    live: root.querySelector('[data-card="live"]'),
    out: root.querySelector('[data-card="out"]')
  };

  function computeState() {
    if (stock <= 0) return 'out';
    if (!dropDate || Date.now() >= dropDate) return 'live';
    return 'teaser';
  }

  var current = '';
  function setState(s) {
    if (s === current) return;
    current = s;
    if (band) {
      band.classList.toggle('jy-drop__band--live', s === 'live');
      band.classList.toggle('jy-drop__band--out', s === 'out');
    }
    Object.keys(cards).forEach(function (k) {
      if (cards[k]) cards[k].classList.toggle('hidden', k !== s);
    });
  }

  /* ---------- countdown ---------- */
  var cdN = {
    d: root.querySelector('[data-cd="d"]'),
    h: root.querySelector('[data-cd="h"]'),
    m: root.querySelector('[data-cd="m"]'),
    s: root.querySelector('[data-cd="s"]')
  };
  function pad(n) { return n < 10 ? '0' + n : '' + n; }
  var landTimer = null;
  function tick() {
    var st = computeState();
    setState(st);
    if (st !== 'teaser') { updateStock(); if (landTimer) { clearInterval(landTimer); landTimer = null; } return; }
    var diff = dropDate - Date.now();
    if (diff < 0) diff = 0;
    var s = Math.floor(diff / 1000);
    if (cdN.d) cdN.d.textContent = pad(Math.floor(s / 86400));
    if (cdN.h) cdN.h.textContent = pad(Math.floor((s % 86400) / 3600));
    if (cdN.m) cdN.m.textContent = pad(Math.floor((s % 3600) / 60));
    if (cdN.s) cdN.s.textContent = pad(s % 60);
  }

  /* ---------- stock bar (real values) ---------- */
  var stockN = root.querySelector('[data-stock-n]');
  var stockFill = root.querySelector('[data-stock-fill]');
  function updateStock() {
    if (stockN) stockN.textContent = Math.max(0, stock);
    if (stockFill) {
      var pct = total > 0 ? Math.max(0, Math.min(100, (stock / total) * 100)) : 0;
      stockFill.style.width = pct + '%';
    }
  }

  /* ---------- entrant proof (real count from backend) ---------- */
  var proofN = root.querySelector('[data-proof-n]');
  function setCount(n) {
    if (proofN && typeof n === 'number' && n >= 0) {
      proofN.textContent = n.toLocaleString('en-US');
    }
  }
  if (endpoint) {
    try {
      fetch(endpoint, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ count: true, product: root.getAttribute('data-product') || '' })
      }).then(function (r) { return r.ok ? r.json() : null; })
        .then(function (d) { if (d && typeof d.count === 'number') setCount(d.count); })
        .catch(function () {});
    } catch (e) {}
  }

  /* ---------- sparks ---------- */
  var sparks = root.querySelector('[data-sparks]');
  if (sparks && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    var frag = document.createDocumentFragment();
    for (var i = 0; i < 22; i++) {
      var el = document.createElement('i');
      el.className = 'jy-drop__spark';
      el.style.insetInlineStart = (i / 22 * 100).toFixed(1) + '%';
      el.style.animationDuration = (2.4 + (i % 5) * 0.5).toFixed(1) + 's';
      el.style.animationDelay = (-(i % 7) * 0.4).toFixed(1) + 's';
      el.style.opacity = (0.4 + (i % 4) * 0.15).toFixed(2);
      frag.appendChild(el);
    }
    sparks.appendChild(frag);
  }

  /* ---------- coupon copy ---------- */
  var cpBtn = root.querySelector('[data-coupon-btn]');
  if (cpBtn) {
    cpBtn.addEventListener('click', function () {
      var code = cpBtn.getAttribute('data-coupon') || '';
      var done = function () {
        var prev = cpBtn.textContent;
        cpBtn.textContent = copiedTxt;
        cpBtn.classList.add('done');
        setTimeout(function () { cpBtn.textContent = prev; cpBtn.classList.remove('done'); }, 1800);
      };
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(code).then(done, done);
      } else { done(); }
    });
  }

  /* ---------- unlock: one click, no fields ---------- */
  var unlockBtn = root.querySelector('[data-unlock]');
  var ov = root.querySelector('[data-ov]');
  var ovClose = root.querySelector('[data-ov-close]');
  var redirFill = root.querySelector('[data-redir-fill]');

  function openOverlay() {
    if (ov) ov.classList.add('open');
    document.documentElement.style.overflow = 'hidden';
    /* kick the progress bar once painted so the CSS width transition runs */
    if (redirFill) {
      requestAnimationFrame(function () {
        requestAnimationFrame(function () { redirFill.classList.add('go'); });
      });
    }
  }
  if (ovClose) ovClose.addEventListener('click', function () {
    if (ov) ov.classList.remove('open');
    document.documentElement.style.overflow = '';
    /* after unlocking, closing the confirmation takes the shopper into the store
       rather than dropping them back on the (now-purposeless) landing */
    if (unlockRedirect && localStorage.getItem('jy_drop_unlocked') === '1') {
      try { window.location.assign(homeUrl); } catch (e) { window.location.href = homeUrl; }
    }
  });
  if (ov) ov.addEventListener('click', function (e) {
    if (e.target === ov) { ov.classList.remove('open'); document.documentElement.style.overflow = ''; }
  });

  if (unlockBtn) {
    unlockBtn.addEventListener('click', function () {
      if (unlockBtn.getAttribute('data-busy') === '1') return; // guard double-tap
      unlockBtn.setAttribute('data-busy', '1');
      unlockBtn.style.opacity = '0.7';

      try {
        /* mark the offer unlocked so the homepage drop section reveals itself */
        localStorage.setItem('jy_drop_unlocked', '1');
        if (product) localStorage.setItem('jy_drop_product', product);
        /* one-shot flag: the homepage teaser scrolls to itself + plays the
           "just added" animation on the next load (cleared after use) */
        sessionStorage.setItem('jy_drop_reveal', '1');
      } catch (e) {}
      /* cookie fallback so the reveal still fires when storage is blocked
         (Safari private mode, storage-partitioned in-app webviews) */
      try { document.cookie = 'jy_drop_unlocked=1;path=/;max-age=2592000;samesite=lax'; } catch (e) {}

      /* optimistic +1 on the on-screen counter */
      if (proofN) { var c = parseInt(proofN.textContent.replace(/\D/g, ''), 10); if (!isNaN(c)) setCount(c + 1); }

      /* count the unlock server-side — anonymous, no name/phone. Best-effort. */
      if (endpoint) {
        try {
          fetch(endpoint, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ bump: true, product: root.getAttribute('data-product') || '' })
          }).catch(function () {});
        } catch (e) {}
      }

      openOverlay();

      /* Skyscanner-style hand-off: brief confirmation, then straight into the
         store where the drop section scrolls in + animates (jy_drop_reveal). */
      if (unlockRedirect) {
        setTimeout(function () {
          try { window.location.assign(homeUrl); } catch (e) { window.location.href = homeUrl; }
        }, 1600);
      } else {
        unlockBtn.setAttribute('data-busy', '0');
        unlockBtn.style.opacity = '';
      }
    });
  }

  updateStock();
  tick();
  if (computeState() === 'teaser') landTimer = setInterval(tick, 1000);
})();
